import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { Checkboxes, RadioButtons } from "../../../FlowConfigurationInputs";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { CheckIfFlowUpdated, getExtension } from "../../../../helpers/helper";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    activeAutom,
    changedFields,
    initialActions,
    openDesktopRecordAtom,
    saveAvailable
} from "../../../../recoil-store/recoil-state";
import { Button } from "@material-ui/core";
import CaptureArea from "../../Ocr/CaptureTextFromImage/CaptureArea";
import Alert from "@material-ui/lab/Alert";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import IncrementDecrement from "../../../FlowConfigurationInputs/IncrementDecrement/IncrementDecrement";
import IncrementByOne from "../../../FlowConfigurationInputs/IncrementByOne/IncrementByOne";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function Pagination({ actions, action, variables, setOpenVariable, variableRender, fromFlow, handleSave }) {
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [upImg, setUpImg] = useState();
    const [value, setValue] = useState(0);
    const [cropImg, setCropImg] = useState("");
    const [fileName, setFileName] = useState("");
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const setOpenDesktopRecord = useSetRecoilState(openDesktopRecordAtom);
    const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const [uniqueValue, setUniqueValue] = useState(action.fields.column?.value ? "column" : "counter");
    const [paginationType, setPaginationType] = useState(action.fields?.paginationType?.value);
    const [pixel, setPixel] = useState(action.fields?.incrementState?.value);
    const [smoothValue, setSmoothValue] = useState(action.fields?.incrementStateSmooth?.value);
    const [maximumRowNumber, setMaximumRowNumber] = useState(action.fields?.maximumRowNumber?.value);

    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-ACTIONS.PAGINATION.';
    const facLabel = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.FIND-AND-CLICK.";
    const options = {
        checkboxes: { label: label + 'SET-UNIQUE' }
    }

    const mouseTypeOptions = {
        radioButtons: {
            data: [
                {
                    value: "right",
                    label: facLabel + "RIGHT",
                },
                {
                    value: "left",
                    label: facLabel + "LEFT",
                },
            ],
            defaultValue: "left",
        }
    };

    const clickTypeOptions = {
        radioButtons: {
            data: [
                {
                    value: "single",
                    label: facLabel + "SINGLE",
                },
                {
                    value: "double",
                    label: facLabel + "DOUBLE",
                },
            ],
            defaultValue: "single",
        }
    };

    useEffect(() => {
        if (!action.fields.imgURL) {
            action.fields.imgURL = { value: "" };
        } else {
            setUpImg(action.fields.imgURL.value);
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        } else {
            setImgCoordinate({ coordinates: action.fields.completedCrop.value });
        }
        if (!action.fields.fileName) {
            action.fields.fileName = { value: "" };
        } else {
            setFileName(action.fields.fileName.value);
        }
        if (!action.fields.mediaSize) {
            action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
        }
        if (!action.fields.gridCrop) {
            action.fields.gridCrop = { value: [] };
        }
        if (!action.fields.source) {
            action.fields.source = {
                value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" },
            };
        }
        if (!action.fields.cropImg) {
            action.fields.cropImg = { value: "" };
        } else {
            setCropImg(action.fields.cropImg.value);
        }
        if (!action.fields.imagePath) {
            action.fields.imagePath = { value: "" };
        }
        if (!action.fields.destination) {
            action.fields.destination = { value: { x: 0, y: 0 } };
        }
        if (!action.fields.source) {
            action.fields.source = { value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" } };
        }
        if (!action.fields.resolution) {
            action.fields.resolution = { value: { width: 0, height: 0 } };
        }
        if (!action.fields.paginationCropOffset) {
            action.fields.paginationCropOffset = { value: [] };
        }
        if (!action.fields.uniqueColumnCropOffset) {
            action.fields.uniqueColumnCropOffset = { value: [] };
        }
        if (!action.fields.difference) {
            action.fields.difference = { value: "" };
        }
        if (!action.fields.highlightedElements) {
            action.fields.highlightedElements = { value: { clickedObj: [], neighbourObj: [] } }
        }

        if (!action.fields.incrementState) {
            action.fields.incrementState = { value: 1 };
            setPixel(action.fields.incrementState.value * 114);
        }

        if (!action.fields.incrementStateSmooth) {
            action.fields.incrementStateSmooth = { value: 1 };
            setSmoothValue(1);
        }

        if (!action.fields.maximumRowNumber) {
            action.fields.maximumRowNumber = { value: 1 };
            setMaximumRowNumber(1);
        }

        if (!action.fields?.paginationType) {
            action.fields.paginationType = { value: "pages" };
            setPaginationType("pages");
        }

        let items = JSON.parse(JSON.stringify(automDetail.items))
        findScopeAction(items);
    }, [action, variables, variableRender]);

    function findScopeAction(nodes, mainNodes) {
        for (let node of nodes) {
            if ('children' in node) {
                findScopeAction(node.children, node);
            } else if (node.id === action.id) {
                if (mainNodes?.fields?.getSS || actions[mainNodes?.id]?.fields?.getSS) {
                    let getSSURL = actions[mainNodes?.id]?.fields?.getSS?.value?.length ? actions[mainNodes.id].fields.getSS.value : mainNodes.fields.getSS?.value
                    //let sameURL = actions[mainNodes?.id]?.fields?.sameURL.value?.length ? actions[mainNodes.id].fields?.sameURL.value : mainNodes.fields.sameURL?.value
                    setUpImg(getSSURL);
                    if (action.fields.destination?.value.x === 0 &&
                        action.fields.destination?.value.y === 0) {
                        action.fields.destination = { value: { x: 0, y: 0 } };
                        action.fields.source = { value: { x: 0, y: 0 } };
                        setImgCoordinate({ coordinates: [] });
                    }
                }
            }
        }
    }

    function resizeImage(url, width, height, x, y, arr) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const imageObj = new Image();
        // set canvas dimensions
        canvas.width = width;
        canvas.height = height;

        imageObj.onload = function () {
            context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
            setCropImg(canvas.toDataURL());
        };
        imageObj.src = url;
    }

    function handleChange(event) {
        setUniqueValue(event.target.value);

        if (event.target.value === "counter") {
            action.fields.counter = { value: true };
            action.fields.column = { value: false };
            const field = initialActionsData[action.id]?.fields.counter;
            const field2 = initialActionsData[action.id]?.fields.column;
            const oldValue = !field ? undefined : field.value;
            const oldValue2 = !field2 ? undefined : field2.value;
            CheckIfFlowUpdated('counter', action, oldValue, true, setSaveAvailable, setChangeFields, changedFieldsState);
            CheckIfFlowUpdated('column', action, oldValue2, false, setSaveAvailable, setChangeFields, changedFieldsState);
        } else if (event.target.value === "column") {
            action.fields.counter = { value: false };
            action.fields.column = { value: true };
            const field = initialActionsData[action.id]?.fields.counter;
            const field2 = initialActionsData[action.id]?.fields.column;
            const oldValue = !field ? undefined : field.value;
            const oldValue2 = !field2 ? undefined : field2.value;
            CheckIfFlowUpdated('counter', action, oldValue, false, setSaveAvailable, setChangeFields, changedFieldsState);
            CheckIfFlowUpdated('column', action, oldValue2, true, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    }

    const handlePaginationType = (type) => {
        setPaginationType(type)
        action.fields.paginationType = { value: type };
    }

    const changeManagement = (v) => {

        const field = initialActionsData[action.id]?.fields.completedCrop;
        const oldValue = !field ? undefined : field.value;

        CheckIfFlowUpdated('completedCrop', action, oldValue, action.fields.completedCrop.value, setSaveAvailable, setChangeFields, changedFieldsState);
        // test yapılamadı hata yaşanıyorsa aşağıdaki kod satırı aktif edilmelidir.
        //if (!oldValue) {
        //      addDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        // }
        //         const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
        // const arr1 = action.fields.completedCrop.value;
        // if (oldValue) {
        //     if (checkTheDifference(arr1, oldValue, ["x","y"])) {
        //         addDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        //     } else {
        //         removeDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        //     }
        // }
        setOpenCaptureArea(v)
    }

    const handleIncrementByOne = (aField, setState, max) => {
        let newValue = parseInt(action.fields[aField].value, 10);
        if (!max || newValue + 1 <= max) {
            newValue++;
            action.fields[aField].value = newValue
            setState(newValue);
            const field = initialActionsData[action.id]?.fields[aField];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(aField, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    const handleDecrementByOne = (aField, setState, state, min) => {
        let newValue = parseInt(action.fields[aField].value, 10);
        if (newValue - 1 >= min) {
            newValue--;
            action.fields[aField].value = newValue
            state - 1 > 0 ? setState(state - 1) : setState(state);
            const field = initialActionsData[action.id]?.fields[aField];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(aField, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    const handleEditingInputFinish = (aField, setState, value, min, max) => {
        let newValue = parseInt(value, 10);

        if (isNaN(newValue) || newValue < min || (max && newValue > max))
            newValue = 1;

        if (newValue >= min && ((max && newValue <= max) || true)) {
            action.fields[aField].value = newValue
            setState(newValue)
            const field = initialActionsData[action.id]?.fields[aField];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(aField, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    }

    const handleEditingInput = (aField, setState, value) => {
        let newValue = parseInt(value, 10);
        if (isNaN(newValue)) {
            action.fields[aField].value = ""
            setState("")
        } else {
            action.fields[aField].value = newValue
            setState(newValue)
        }
        const field = initialActionsData[action.id]?.fields[aField];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated(aField, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
    }

    const handleIncrement = () => {
        action.fields.incrementState.value++;
        setPixel(action.fields.incrementState.value * 114);
        const field = initialActionsData[action.id]?.fields.incrementState;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('incrementState', action, oldValue, action.fields.incrementState.value, setSaveAvailable, setChangeFields, changedFieldsState);
    };

    const handleDecrement = () => {
        if (action.fields.incrementState.value - 1 > 0) {
            action.fields.incrementState.value--;
            setPixel(action.fields.incrementState.value * 114);
            const field = initialActionsData[action.id]?.fields.incrementState;
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated('incrementState', action, oldValue, action.fields.incrementState.value, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    return (
        <>
            {
                fromFlow ?
                    <div className="conf-field-container">
                        <div>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenDesktopRecord(true)}
                                // onClick={() => setOpenCaptureArea(true)}
                                style={{
                                    background: "#031226",
                                    boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                                    borderRadius: 4,
                                    color: "#fff",
                                    fontWeight: 700,
                                    fontSize: '11px'
                                }}
                            >
                                {t(label + "INITIATE-SELECTOR")}
                            </Button>
                        </div>
                        {openCaptureArea && (
                            <CaptureArea
                                imgCoordinate={{ coordinates: action.fields.completedCrop.value }}
                                setImgCoordinate={setImgCoordinate}
                                action={action}
                                upImg={upImg}
                                setOpenCaptureArea={(v) => changeManagement(v)}
                                setOpenVariable={setOpenVariable}
                                variables={variables}
                                isGrid={value}
                                isGetText={true}
                            />
                        )}
                    </div>
                    :
                    <></>
            }
            <IncrementByOne
                action={action}
                handleIncrement={() => handleIncrementByOne("maximumRowNumber", setMaximumRowNumber)}
                handleDecrement={() => handleDecrementByOne("maximumRowNumber", setMaximumRowNumber, maximumRowNumber, 1)}
                handleEditingInput={(aField, setState, value) => handleEditingInputFinish(aField, setState, value, 1)}
                handleEditingInputChange={(aField, setState, value) => handleEditingInput(aField, setState, value)}
                field={"maximumRowNumber"}
                labelText={"MAXIMUM-ROW-NUMBER"}
                editable={true}
                setState={setMaximumRowNumber}
            />
            <div className="conf-field-container mail-server-button-group w275">
                <div
                    onClick={() => handlePaginationType("pages")}
                    className={
                        paginationType === "pages"
                            ? "mail-server-button-active"
                            : "mail-server-button"
                    }
                    style={{ width: "80px" }}
                >
                    {t(label + "PAGES")}
                </div>
                <div
                    onClick={() => handlePaginationType("scroll")}
                    className={
                        paginationType === "scroll"
                            ? "mail-server-button-active"
                            : "mail-server-button"
                    }
                    style={{ width: "80px" }}
                >
                    {t(label + "SCROLL")}
                </div>
                <div
                    onClick={() => handlePaginationType("scroll-smooth")}
                    className={
                        paginationType === "scroll-smooth"
                            ? "mail-server-button-active"
                            : "mail-server-button"
                    }
                    style={{ width: "100px" }}
                >
                    {t(label + "SCROLL-SMOOTH")}
                </div>
            </div>
            {
                paginationType === "scroll" && (
                    <>
                        <IncrementDecrement action={action} handleIncrement={handleIncrement} handleDecrement={handleDecrement} />
                    </>
                )
            }
            {
                paginationType === "scroll-smooth" && (
                    <>
                        <div className="conf-field-container">
                            <FieldLabel name={t(label + 'SCROLL-DURATION')} />
                            <TextInput action={action} inputName="duration" variables={variables}
                                setOpenVariable={setOpenVariable} filter="string" />
                            <small className="small-helper">{t(label + "SCROLL-DURATION-HELPER")}</small>
                        </div>
                        <IncrementByOne
                            action={action}
                            handleIncrement={() => handleIncrementByOne("incrementStateSmooth", setSmoothValue, 3)}
                            handleDecrement={() => handleDecrementByOne("incrementStateSmooth", setSmoothValue, smoothValue, 1)}
                            field={"incrementStateSmooth"}
                            labelText={"SCROLL-SPEED"}
                            setState={setSmoothValue}
                        />
                    </>
                )
            }
            <div className="conf-field-container" style={{ display: "none" }}>
                <FieldLabel name={t(facLabel + 'TYPE')} />
                <RadioButtons
                    action={action}
                    inputName="mouseType"
                    options={mouseTypeOptions.radioButtons}
                    isRequired
                />
            </div>
            <div className="conf-field-container" style={{ display: "none" }}>
                <FieldLabel name={t(facLabel + 'CLICK-TYPE')} />
                <RadioButtons
                    action={action}
                    inputName="clickType"
                    options={clickTypeOptions.radioButtons}
                    isRequired
                />
            </div>

            {
                !fromFlow && handleSave && (
                    <Button
                        variant="outlined"
                        className="desktop-actions-button"
                        onClick={() => handleSave()}
                    >
                        {t(facLabel + "CREATE-SELECTOR")}
                    </Button>
                )
            }
        </>
    );
}
export default Pagination;